import { instance } from '@shared/api/config';
import { path } from '../../config';

// OSI-798: Отчёт по должникам на конец прошлого месяца.
// Дёргает эндпоинт oci-docs /api/report/debts-prev-month/{osiId}
// (через прокси /doc/api/report/debts-prev-month/{osiId}).
// Контракт запроса/ответа полностью совпадает с отчётом по должникам (debts):
// те же query-параметры begin/end (период = текущий месяц) и тот же формат ответа (base64 xlsx).
// Поддерживает сворачивание дочерних помещений (паркинги/кладовки влиты в родителя) — как у должников.
export const getDebtsPrevMonthByOsiId = (
  osiId: number,
  period: {
    begin: any;
    end: any;
  },
  // Флаг «Свернуть дочерние помещения»: при true дописываем query-параметр для бэкенда oci-docs
  collapseChildren = false
): Promise<any> =>
  instance.get(
    `${path}/debts-prev-month/${osiId}?begin=${period.begin}&end=${period.end}${
      collapseChildren ? '&collapseChildren=true' : ''
    }`
  );
